/**
 * ShopMint — Trust & Conversion Layer
 * ------------------------------------------------------------------
 * Three quiet additions. None of them change how a page looks at
 * rest, and none of them add a floating widget:
 *
 *   1. Product pages — a small assurance row under the buy buttons.
 *   2. Cart page     — a progress bar toward free delivery.
 *   3. Site-wide     — hides the flash-sale timer once it has run
 *                      out, so the store never shows 00:00:00:00.
 *
 * No dependencies, no tracking, no network calls except reading the
 * shopper's own cart. Everything is driven by CONFIG below.
 * ------------------------------------------------------------------
 */
(function () {
  'use strict';

  var CONFIG = {
    /* Keep this the same as the threshold advertised on the homepage
       trust badges. Rupees, not paise. */
    freeDeliveryFrom: 499,
    symbol: '₹',

    /* ---- Delivery estimate ---------------------------------------
       Deliberately OFF. A date the shopper can hold you to is one of
       the strongest things an Indian store can show — and one of the
       most expensive things to get wrong. Switch this to true only
       once the two numbers below match what you can actually do.   */
    showDeliveryEstimate: false,
    dispatchDays: 2,   // working days before the parcel leaves you
    transitDays: 4     // working days in transit after that
  };

  var ICON = {
    truck:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M3 7.5h11v9H3z"/><path d="M14 11h3.8l2.7 2.8v2.7H14z"/>' +
      '<circle cx="7" cy="17.5" r="1.7"/><circle cx="17.2" cy="17.5" r="1.7"/></svg>',
    returns:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M20 12a8 8 0 1 1-2.4-5.7"/><path d="M20 4.5V10h-5.5"/></svg>',
    lock:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<rect x="4.5" y="10.5" width="15" height="9.5" rx="2"/><path d="M8 10.5V7.6a4 4 0 0 1 8 0v2.9"/></svg>',
    check:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M20 6.5 9.5 17 4 11.5"/></svg>'
  };

  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

  function rupees(paise) {
    return CONFIG.symbol + Math.ceil(paise / 100).toLocaleString('en-IN');
  }

  /* Adds working days, skipping Sundays. */
  function addWorkingDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++;
    }
    return d;
  }

  /* ---------------------------------------------------------------
     1. Product page assurance row
     --------------------------------------------------------------- */

  function buildAssurance() {
    var container = document.querySelector('.product__info-container');
    if (!container) return;
    if (container.querySelector('.sm-assure')) return;

    var anchor = container.querySelector('.product-form__buttons') ||
                 container.querySelector('product-form');
    if (!anchor) return;

    /* Never inject into a quick-add popup or the cart. */
    if (anchor.closest('quick-add-modal, .quick-add-modal, cart-drawer')) return;

    var items = [
      [ICON.truck,   'Free delivery over ' + CONFIG.symbol + CONFIG.freeDeliveryFrom],
      [ICON.returns, 'Easy 7-day returns'],
      [ICON.lock,    'Secure checkout']
    ];

    var wrap = document.createElement('div');
    wrap.className = 'sm-assure';
    wrap.innerHTML = items.map(function (it) {
      return '<div class="sm-assure__item">' + it[0] + '<span>' + it[1] + '</span></div>';
    }).join('');

    anchor.insertAdjacentElement('afterend', wrap);

    if (CONFIG.showDeliveryEstimate) {
      var eta = addWorkingDays(new Date(), CONFIG.dispatchDays + CONFIG.transitDays);
      var label = DAYS[eta.getDay()] + ', ' + eta.getDate() + ' ' + MONTHS[eta.getMonth()];
      var p = document.createElement('p');
      p.className = 'sm-eta';
      p.innerHTML = 'Order today — expected delivery by <strong>' + label + '</strong>';
      wrap.insertAdjacentElement('afterend', p);
    }
  }

  /* ---------------------------------------------------------------
     2. Cart page free-delivery progress
     --------------------------------------------------------------- */

  var cartObserver = null;
  var cartTimer = null;

  function renderCartProgress() {
    var blocks = document.querySelector('.cart__blocks');
    if (!blocks) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cartObserver) cartObserver.disconnect();

        var existing = blocks.querySelector('.sm-ship');
        if (existing) existing.remove();

        if (cart.item_count > 0) {
          var threshold = CONFIG.freeDeliveryFrom * 100;
          var remaining = threshold - cart.total_price;
          var pct = Math.min(100, (cart.total_price / threshold) * 100);
          var done = remaining <= 0;

          var el = document.createElement('div');
          el.className = 'sm-ship' + (done ? ' sm-ship--done' : '');
          el.innerHTML =
            '<p class="sm-ship__text">' +
              (done ? ICON.check : ICON.truck) +
              '<span>' +
                (done
                  ? 'Free delivery unlocked on this order'
                  : 'Add <strong>' + rupees(remaining) + '</strong> more for free delivery') +
              '</span>' +
            '</p>' +
            '<div class="sm-ship__track"><div class="sm-ship__fill" style="width:' + pct.toFixed(1) + '%"></div></div>';

          blocks.insertAdjacentElement('afterbegin', el);
        }

        if (cartObserver) observeCart();
      })
      .catch(function () { if (cartObserver) observeCart(); });
  }

  function scheduleCartRender() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(renderCartProgress, 250);
  }

  function observeCart() {
    var target = document.querySelector('main') || document.body;
    if (!cartObserver) {
      cartObserver = new MutationObserver(function (muts) {
        var ours = muts.every(function (m) {
          return m.target.closest && m.target.closest('.sm-ship');
        });
        if (!ours) scheduleCartRender();
      });
    }
    cartObserver.observe(target, { childList: true, subtree: true });
  }

  function initCart() {
    if (!document.querySelector('.cart__blocks')) return;
    observeCart();
    renderCartProgress();
  }

  /* ---------------------------------------------------------------
     3. Hide an expired flash-sale timer
     --------------------------------------------------------------- */

  function timerRow() {
    var values = document.querySelectorAll('.countdown-value');
    if (!values.length) return null;
    var node = values[0];
    while (node && node.parentElement) {
      node = node.parentElement;
      if (node.querySelectorAll('.countdown-value').length === values.length) return node;
    }
    return null;
  }

  function checkCountdown() {
    var values = document.querySelectorAll('.countdown-value');
    if (!values.length) return;
    var row = timerRow();
    if (!row) return;

    var allZero = Array.prototype.every.call(values, function (v) {
      return /^0+$/.test(v.textContent.trim());
    });

    if (allZero) row.setAttribute('data-sm-expired', 'true');
    else row.removeAttribute('data-sm-expired');
  }

  function initCountdown() {
    var banner = document.querySelector('.countdown-banner');
    if (!banner) return;
    checkCountdown();
    new MutationObserver(checkCountdown)
      .observe(banner, { childList: true, subtree: true, characterData: true });
  }

  /* --------------------------------------------------------------- */

  function init() {
    buildAssurance();
    initCart();
    initCountdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run when the theme editor swaps a section in or out. */
  document.addEventListener('shopify:section:load', init);
})();
